import React from 'react';
import UsersListItem from './UsersListItem';
import EmptyTable from '../../../Base/Empty/EmptyTable';

const UsersList = ({ users, loading }) => (
  <table className="dash-table dash-table--fees">
    <thead>
      <tr>
        <td>
          <span className="table-title table-title--admin">ID</span>
        </td>
        <td>
          <span className="table-title">Full Name</span>
        </td>
        <td>
          <span className="table-title">Email</span>
        </td>
        <td>
          <span className="table-title">Mobile Phone</span>
        </td>
        <td>
          <span className="table-title" style={{ width: '130px' }}>
            Last Login Country
          </span>
        </td>
        <td>
          <span className="table-title">IP</span>
        </td>
        <td>
          <span className="table-title">Status</span>
        </td>
        <td>
          <span className="table-title">Last Login</span>
        </td>
        <td>
          <span className="table-title">Created</span>
        </td>
        <td>
          <span className="table-title">
            Approved
            <br /> documents
            <br /> (Ondato)
          </span>
        </td>
        <td>
          <span className="table-title">
            Approved
            <br /> documents
            <br /> (Shuftipro)
          </span>
        </td>
        <td>
          <span className="table-title">KYC</span>
        </td>
        <td>
          <span className="table-title">Action</span>
        </td>
      </tr>
    </thead>

    <EmptyTable loading={loading} isEmpty={!users?.length} colSpan={12}>
      {users?.map(user => (
        <UsersListItem key={user.id} user={user} />
      ))}
    </EmptyTable>
  </table>
);

export default UsersList;
